export const featureName = 'CREDIT_CARD';